import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import { fetchAnnouncementById, clearSelectedAnnouncement } from "../../../redux/slice/announcementsSlice";
import { useHasPermission } from "../../../hooks/useHasPermission";
import { toast } from "react-toastify";

export default function AnnouncementDetail() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { selected, loading, error } = useSelector(
    (state) => state.announcements
  );

  const canView = useHasPermission("Announcements-view");
  const canManage = useHasPermission("Announcements-manage");

  /* FETCH ================= */
  useEffect(() => {
    if (!canView) return;

    dispatch(fetchAnnouncementById(id));

    return () => {
      dispatch(clearSelectedAnnouncement());
    };
  }, [dispatch, id, canView]);

  /* PERMISSION CHECK ================= */
  if (!canView) {
    return (
      <p className="perm-msg">
        You don’t have permission to view this announcement!
      </p>
    );
  }

  /* LOADING ================= */
  if (loading) {
    return (
      <div className="container-fluid">
        <Breadcrumb />
        <p className="loading-msg">Loading announcement...</p>
      </div>
    );
  }

  /* ERROR ================= */
  if (error) {
    return (
      <div className="container-fluid">
        <Breadcrumb />
        <p className="server-error-msg">
          Unable to load announcement details.
        </p>
      </div>
    );
  }

  /* NO DATA ================= */
  if (!selected) {
    return null;
  }

  const likeCount = selected.likeCount
    ? Object.keys(selected.likeCount).length
    : 0;

  const commentCount = selected.commentCount
    ? Object.keys(selected.commentCount).length
    : 0;

  const handleEdit = () => {
    if (!canManage) {
      toast.error("You don't have permission to edit announcements");
      return;
    }
    navigate(`/admin/announcements/${id}/edit`);
  };

  return (
    <div className="container-fluid" style={{ marginBottom: "30px" }}>
      <Breadcrumb />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>{selected.title}</h4>
        {canManage && (
          <button type="button" className="primary-btn" onClick={handleEdit}>
            Edit
          </button>
        )}
      </div>

      <div className="card">
        <div className="card-body aaaaaaaaaaa">
          <div className="mb-3">
            <span className={`badge ${selected.status === "PUBLISHED" ? "bg-success" : selected.status === "SCHEDULED" ? "bg-warning text-dark" : "bg-secondary"}`} >
              {selected.status || "DRAFT"}
            </span>
          </div>
          <div className="mb-3">
            <strong>Type:</strong> {selected.type || "-"}
          </div>
          <div className="mb-3">
            <strong>Publish At:</strong>{" "}
            {selected.publishAt
              ? new Date(selected.publishAt).toLocaleString()
              : "-"}
          </div>
          <div className="mb-3">
            <strong>Published At:</strong>{" "}
            {selected.publishedAt
              ? new Date(selected.publishedAt).toLocaleString()
              : "-"}
          </div>
          <div className="mb-3">
            <strong>Created By:</strong>{" "}
            {selected.createdByName || "-"}
          </div>
          <div className="mb-3">
            <strong>Created Atasasasas:</strong>{" "}
            {selected.createdAt
              ? new Date(selected.createdAt).toLocaleString()
              : "-"}
          </div>
          <div className="mb-3">
            <strong>Likes:</strong> {likeCount}
            &nbsp;&nbsp;&nbsp;
            <strong>Comments:</strong> {commentCount}
          </div>

          <hr />

          <div>
            <strong>Description:</strong>
            <div className="mt-2" dangerouslySetInnerHTML={{ __html: selected.content || "", }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
